/* istanbul ignore file */
import { connect } from 'react-redux'
import Step2 from './Step2'
import { navigateTo } from '../../actions/navigation'
import { requestRates } from '../../actions/rates'
import { requestUser } from '../../actions/user'
import { tokenDataSelector } from '../../selectors/token'
import { isUserLoadedSelector } from '../../selectors/user'
import { requestBuildBooking } from '../../actions/booking'
import { vehicleListSelector, ratesDataSelector, ratesIsLoadingSelector, ratesErrorSelector, ratesFiltersConfigSelector } from '../../selectors/rates'
import { trackGA4Event } from '../../actions/analytics'
function mapStateToProps (state) {
    return {
        vehicles: vehicleListSelector(state),
        searchId: ratesDataSelector(state).id,
        ratesPending: ratesIsLoadingSelector(state),
        searchError: ratesErrorSelector(state),
        filtersConfig: ratesFiltersConfigSelector(state),
        token: tokenDataSelector(state),
        userLoaded: isUserLoadedSelector(state),
    }
}

export default connect(
    mapStateToProps,
    {
        navigateTo,
        requestRates,
        requestUser,
        requestBuildBooking,
        trackGA4Event,
    }
)(Step2)
